
import React, { useState } from "react";
import PropTypes from 'prop-types';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './login.css';
import '../UserResponsive.css';

export default function Login ({ setToken })  {


    const [email, setUserName] = useState();
    const [password, setPassword] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [remember, setRemember] = useState(false);
    
    const [errores, setErrores] = useState("");

    const handleSubmit = async e => {
        e.preventDefault();
        const tokenObtenido = await loginUser({
            email,
            password,
            remember_me: remember
        });

        if (tokenObtenido && tokenObtenido.access_token) {
            setToken(tokenObtenido);
            return;
        }

        setToken(null);
        if (tokenObtenido && tokenObtenido.message) {
            setErrores(tokenObtenido.message);
        }
        else if (tokenObtenido && tokenObtenido.errors && tokenObtenido.errors.email) {
            setErrores(tokenObtenido.errors.email);
        }
    }
    let url = `${process.env.PUBLIC_URL}/logo2026.jpg`;

    return (
        <section className="login-page">
            <div className="login-card">
                <div className="login-logo-wrap">
                    <img src={url}
                        onError={(e) => e.target.src='https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png'}
                        alt="Logo Mundial 2026" className="login-logo" />
                </div>
                <div className="login-header">
                    <p className="login-kicker">Polla Gol 2026</p>
                    <h1>Ingresar</h1>
                    <p>Haz tus apuestas del mundial 2026</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input type="email" className="form-control rounded-left" placeholder="Email" autoComplete="email" onChange={e => setUserName(e.target.value)} required />
                    </div>
                    <div className="form-group">
                        <div className="password-input-wrap">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className="form-control rounded-left password-input"
                                placeholder="Password"
                                autoComplete="current-password"
                                onChange={e => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={() => setShowPassword((currentValue) => !currentValue)}
                                aria-label={showPassword ? 'Ocultar clave' : 'Ver clave'}
                            >
                                <i className={showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'} />
                            </button>
                        </div>
                    </div>
                    <div className="form-group">
                        <button type="submit" className="form-control btn btn-primary rounded submit px-3">Login</button>
                    </div>
                    <div className="form-group login-actions">
                        <label className="checkbox-wrap checkbox-primary">Recordarme
                            <input type="checkbox" checked={remember} onChange={e => setRemember(e.target.checked)} />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                    <p className="text-danger">{errores}</p>
                </form>
            </div>
        </section>
    );
}

async function loginUser(credentials) {
    
//    var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/auth/login', {
    var respuesta = fetch(process.env.REACT_APP_URL+'auth/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(credentials)
    })
    // .then((response) => {
    //         return response; 
    // });
    .then(data => data.json());    
    return respuesta;
}


Login.propTypes = {
    setToken: PropTypes.func.isRequired
};
